<div
    *ngIf="productBundles.length > 0"
    class="row bundles"
>
    <div class="col-md-12">
        <h3> Bundle And Save </h3>
    </div>
    <div class="col-md-12">
        <div class="cart">
            <div
                *ngFor="let productBundle of productBundles"
                class="product-item p-2"
            >
                <app-product-item
                    [brandId]="brandId"
                    [product]="productBundle"
                    (addProduct)="addItemToCart($event)"
                >
                </app-product-item>
                <div
                    *ngIf="!(brandId === BrandEnum.CELPIP && product.productTypeId == isCelpipPracticeTest)"
                    class="mt-5"
                >
                    <strong>Bundle and Save {{productBundle.actualValue - productBundle.listPrice | currency : productBundle.currencyCode + " "}}</strong>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal
    #addItemWarning
    title="Note"
    [body]="addItemWarningMesssage"
    (clickPositive)="finalizeAdd()"
    isConfirm="true"
>
</app-modal>
